import { render } from "./Icon.vue?vue&type=template&id=5d8d4375"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Icon.vue"]])

export default __exports__